<template>
  <div style="width: 1200px; margin: auto">
    <!-- <div style="display: flex;justify-content: flex-end;width: 100%;">
			<div class="common_search_box">
				<Input v-model="kw" clearable @on-enter="toSearch" placeholder="请输入验证码查询">
				</Input>
				<div class="btn_box">
					<div @click="toSearch">查询</div>
				</div>
			</div>
		</div> -->
    <div class="applyChangeTxt">{{ applyChangeTxt }}</div>

    <div :style="titStyle" class="table_box">
      <div class="cell1">
        <div class="cell_item">
          <div class="tit" style="width: 14%">入黔类型</div>
          <div class="inp" style="padding-left: 10px">
            <el-radio-group v-model="form.kz.isOffice" @change="isOfficeChange">
              <el-radio label="0">分公司</el-radio>
              <el-radio label="1">办事处</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div v-if="form.kz.isOffice === '1'" class="cell2">
        <div class="tit">
          <span>总公司</span>
          <span>基本情况</span>
        </div>
        <!-- 大框 -->
        <div class="table_item">
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td"><span>单位名称</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.dwmcMain"
                  placeholder="请输入单位名称"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td"><span>统一社会</span><span>信用代码</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.accountMain"
                  placeholder="请输入统一社会信用代码"
                ></Input>
              </div>
            </div>
          </div>
          <!-- 一行 -->
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td">企业类型</div>
              <div class="inp account">
                <el-select
                  v-model="form.companyType"
                  placeholder="请选择企业类型"
                  @change="companyTypeChange"
                >
                  <el-option
                    v-for="item in companyTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="table_cell">
            <div class="td_item" style="width: 60%">
              <div class="td">企业注册地</div>
              <div class="inp">
                <!--                <Cascader v-model="form.add" :data="addData" />-->
                <el-cascader
                  v-if="isShow"
                  ref="CityRef"
                  v-model="form.areaCodeArr"
                  :props="propsCity"
                  placeholder="请选择企业注册地所在省市县"
                  style="width: 100%"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>
            <div class="td_item">
              <!--              <div class="td"><span>企业注册地</span><span>详细地址</span></div>-->
              <div class="inp">
                <Input
                  v-model.trim="form.zcdz"
                  placeholder="请输入详细地址"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div :style="{ width: width * 2 + 'px' }" class="td_item">
              <div class="td">单位性质</div>
              <RadioGroup v-model="form.dwxz" class="radio_box">
                <Radio v-for="(it, i) in radioList" :key="i" :label="it.label">
                  <Icon type="social-apple"></Icon>
                  <span>{{ it.label }}</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="td_item">
              <div class="td">
                <span>注册资金</span><span style="font-size: 14px">(万元)</span>
              </div>
              <div class="inp">
                <Input
                  v-model.trim="form.zczj"
                  placeholder="请输入注册资金"
                  type="number"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">职工总人数</div>
              <div class="inp">
                <Input
                  v-model.trim="form.zgzrs"
                  placeholder="请输入职工总人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td"><span>中级及以上</span><span>职称人数</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.zjyszcrs"
                  placeholder="请输入人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">单位电话</div>
              <div class="inp">
                <Input
                  v-model.trim="form.dwdh"
                  placeholder="请输入单位电话"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">邮政编码</div>
              <div class="inp">
                <Input
                  v-model.trim="form.yb"
                  placeholder="请输入邮政编码"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">企业邮箱</div>
              <div class="inp">
                <Input
                  v-model.trim="form.qyyx"
                  placeholder="请输入企业邮箱"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">通讯地址</div>
              <div class="inp">
                <Input
                  v-model.trim="form.txdz"
                  placeholder="请输入通讯地址"
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell2">
        <div class="tit"><span>在黔</span><span>基本情况</span></div>
        <!-- 大框 -->
        <div class="table_item">
          <!-- 一行 -->
          <div v-if="form.kz.isOffice === '0'" class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td"><span>在黔分公司</span><span>单位名称</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbFzjgmc"
                  placeholder="请输入申请入会单位名称"
                ></Input>
              </div>
            </div>
          </div>
          <div v-if="form.kz.isOffice === '0'" class="table_cell">
            <div :style="{ width: width * 2 + 'px' }" class="td_item">
              <div class="td"><span>统一社会</span><span>信用代码</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbTyxydm"
                  placeholder="请输入申请入会单位统一社会信用代码"
                ></Input>
              </div>
            </div>
          </div>
          <div v-if="form.kz.isOffice === '0'" class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td">企业类型</div>
              <div class="inp account">
                <el-select
                  v-model="form.kz.companyType"
                  placeholder="请选择企业类型"
                  @change="companyTypeChange"
                >
                  <el-option
                    v-for="item in companyTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="form.kz.isOffice === '0'" class="table_cell">
            <div class="td_item" style="width: 60%">
              <div class="td">企业注册地</div>
              <div class="inp">
                <el-cascader
                  v-if="isShow"
                  ref="ZqCityRef"
                  v-model="form.kz.areaCodeArr"
                  :props="propsCity"
                  placeholder="请选择企业注册地所在省市县"
                  style="width: 100%"
                  @change="handleChangeZqjbQyzcdq"
                ></el-cascader>
              </div>
            </div>
            <div class="td_item">
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbQyzcdq"
                  placeholder="请输入详细地址"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div :style="{ width: width * 2 + 'px' }" class="td_item">
              <div class="td">通讯地址</div>
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbTxdz"
                  placeholder="请输入通讯地址"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">单位电话</div>
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbDwdh"
                  placeholder="请输入单位电话"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">职工总人数</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqjbZgzrs"
                  placeholder="请输入职工总人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td"><span>中级及以上</span><span>职称人数</span></div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqjbZjyszcrs"
                  placeholder="请输入人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">企业邮箱</div>
              <div class="inp">
                <Input
                  v-model.trim="form.kz.zqjbQyyx"
                  placeholder="请输入企业邮箱"
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell2">
        <div class="tit"><span>在黔</span><span>负责人</span></div>
        <!-- 大框 -->
        <div class="table_item">
          <!-- 一行 -->
          <div class="table_cell">
            <div class="td_item">
              <div class="td">姓名</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrName"
                  placeholder="请输入姓名"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">性别</div>
              <RadioGroup v-model="form.kz.zqfzrSex" class="radio_box">
                <Radio v-for="(it, i) in sexRadio" :key="i" :label="it.label">
                  <Icon type="social-apple"></Icon>
                  <span>{{ it.label }}</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="td_item">
              <div class="td">出生年月</div>
              <div class="inp">
                <DatePicker
                  :clearable="false"
                  :value="form.kz.zqfzrCsny"
                  format="yyyy-MM-dd"
                  placeholder="请选择出生年月"
                  transfer
                  type="date"
                  @on-change="getLong"
                ></DatePicker>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td">身份证号</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrSfzh"
                  placeholder="请输入身份证号"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td"><span>其他社会</span><span>职务</span></div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrQtshzw"
                  placeholder="请输入其他社会职务"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">职称</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrZc"
                  placeholder="请输入职称"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">政治面貌</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrZzmm"
                  placeholder="请输入政治面貌"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">学历</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrXl"
                  placeholder="请输入学历"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">专业</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrZy"
                  placeholder="请输入专业"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">手机号码</div>
              <div class="inp">
                <Input
                  v-model="form.kz.zqfzrSjhm"
                  placeholder="请输入手机号码"
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell2">
        <div class="tit"><span>在黔</span><span>联系人</span></div>
        <!-- 大框 -->
        <div class="table_item">
          <!-- 一行 -->
          <div class="table_cell">
            <div class="td_item">
              <div class="td">姓名</div>
              <div class="inp">
                <Input
                  v-model="form.kz.lxrName"
                  placeholder="请输入姓名"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">性别</div>
              <RadioGroup v-model="form.kz.lxrSex" class="radio_box">
                <Radio v-for="(it, i) in sexRadio" :key="i" :label="it.label">
                  <Icon type="social-apple"></Icon>
                  <span>{{ it.label }}</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="td_item">
              <div class="td">手机号码</div>
              <div class="inp">
                <Input
                  v-model="form.kz.lxrSjhm"
                  placeholder="请输入手机号码"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">职务</div>
              <div class="inp">
                <Input v-model="form.kz.lxrZw" placeholder="请输入职务"></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">办公电话</div>
              <div class="inp">
                <Input
                  v-model="form.kz.lxrBgdh"
                  placeholder="请输入办公电话"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">邮箱</div>
              <div class="inp">
                <Input v-model="form.kz.lxrYx" placeholder="请输入邮箱"></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--入黔类型：分公司-->
      <div v-if="form.kz.isOffice === '0'" class="cell2">
        <div class="tit">
          <span>总公司</span>
          <span>基本情况</span>
        </div>
        <!-- 大框 -->
        <div class="table_item">
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td"><span>单位名称</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.dwmcMain"
                  placeholder="请输入单位名称"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td"><span>统一社会</span><span>信用代码</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.accountMain"
                  placeholder="请输入统一社会信用代码"
                ></Input>
              </div>
            </div>
          </div>
          <!-- 一行 -->
          <div v-if="form.kz.isOffice === '1'" class="table_cell">
            <div class="td_item" style="width: 100%">
              <div class="td">企业类型</div>
              <div class="inp account">
                <el-select
                  v-model="form.companyType"
                  placeholder="请选择企业类型"
                  @change="companyTypeChange"
                >
                  <el-option
                    v-for="item in companyTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item" style="width: 60%">
              <div class="td">企业注册地</div>
              <div class="inp">
                <!--                <Cascader v-model="form.add" :data="addData" />-->
                <el-cascader
                  v-if="isShow"
                  ref="CityRef"
                  v-model="form.areaCodeArr"
                  :props="propsCity"
                  placeholder="请选择企业注册地所在省市县"
                  style="width: 100%"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>
            <div class="td_item">
              <!--              <div class="td"><span>企业注册地</span><span>详细地址</span></div>-->
              <div class="inp">
                <Input
                  v-model.trim="form.zcdz"
                  placeholder="请输入详细地址"
                ></Input>
              </div>
            </div>
          </div>
          <!--          <div v-if="form.isOffice === 1" class="table_cell">-->
          <!--            <div class="td_item">-->
          <!--              <div class="td">企业注册地</div>-->
          <!--              <div class="inp">-->
          <!--                <Input-->
          <!--                  v-model.trim="form.zcdz"-->
          <!--                  placeholder="请输入企业注册地"-->
          <!--                ></Input>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="table_cell">
            <div :style="{ width: width * 2 + 'px' }" class="td_item">
              <div class="td">单位性质</div>
              <RadioGroup v-model="form.dwxz" class="radio_box">
                <Radio v-for="(it, i) in radioList" :key="i" :label="it.label">
                  <Icon type="social-apple"></Icon>
                  <span>{{ it.label }}</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="td_item">
              <div class="td">
                <span>注册资金</span><span style="font-size: 14px">(万元)</span>
              </div>
              <div class="inp">
                <Input
                  v-model.trim="form.zczj"
                  placeholder="请输入注册资金"
                  type="number"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">职工总人数</div>
              <div class="inp">
                <Input
                  v-model.trim="form.zgzrs"
                  placeholder="请输入职工总人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td"><span>中级及以上</span><span>职称人数</span></div>
              <div class="inp">
                <Input
                  v-model.trim="form.zjyszcrs"
                  placeholder="请输入人数"
                  type="number"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">单位电话</div>
              <div class="inp">
                <Input
                  v-model.trim="form.dwdh"
                  placeholder="请输入单位电话"
                ></Input>
              </div>
            </div>
          </div>
          <div class="table_cell">
            <div class="td_item">
              <div class="td">邮政编码</div>
              <div class="inp">
                <Input
                  v-model.trim="form.yb"
                  placeholder="请输入邮政编码"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">企业邮箱</div>
              <div class="inp">
                <Input
                  v-model.trim="form.qyyx"
                  placeholder="请输入企业邮箱"
                ></Input>
              </div>
            </div>
            <div class="td_item">
              <div class="td">通讯地址</div>
              <div class="inp">
                <Input
                  v-model.trim="form.txdz"
                  placeholder="请输入通讯地址"
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell2">
        <div class="tit"><span>上传附件</span></div>
        <!-- 大框 -->
        <div class="table_item">
          <!-- 一行 -->
          <div class="img_box">
            <div v-for="(it, i) in imgZD" :key="i" @click="toUpload(it.label)">
              <div class="img">
                <div v-if="form[it.label]" class="demo-upload-list">
                  <template>
                    <img :src="$previewImg + form[it.label]" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(it.label)"
                      ></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native="handleRemove(it.label)"
                      ></Icon>
                    </div>
                  </template>
                </div>
                <Upload
                  v-else
                  ref="upload"
                  :action="$imgHost"
                  :data="imgOption.data"
                  :format="imgOption.format"
                  :max-size="imgOption.maxSize"
                  :on-exceeded-size="handleMaxSize"
                  :on-format-error="handleFormatError"
                  :on-success="handleSuccess"
                  :show-upload-list="false"
                  type="drag"
                >
                  <div class="jia">+</div>
                </Upload>
              </div>
              <div>{{ it.name1 }}</div>
              <div>{{ it.name2 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell2">
        <div class="tit"><span>变更原因</span></div>
        <!-- 大框 -->
        <div class="table_item">
          <!-- 一行 -->
          <div class="img_box changeReason">
            <Input
              v-model="form.changeReason"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :maxlength="300"
              placeholder="请输入变更原因"
              show-word-limit
              type="textarea"
            />
          </div>
        </div>
      </div>
      <Button class="btn" long type="primary" @click="submit">提交</Button>
      <Modal v-model="visible" title="">
        <img v-if="visible" :src="imgUrl" style="width: 100%" />
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import {
  applicationSubmit,
  applicationUpdateApply,
  getVipxx,
  infoQuery,
} from "@/api/other";
import { yzPhone, yzAllCall, yzSfz, yzEmail } from "@/utils/util";
import { getDqCode, getQueryDictltemsByCode } from "@/api/home/basicInfo";

export default {
  components: {},
  computed: {
    titStyle() {
      return {
        "--height": this.height + "px", //输入框高度
        "--border": `${this.borderWidth}px solid #159FFF`, //边框
        "--gWidth": `${this.width}px`, //边框
      };
    },
  },
  props: {
    // typeName: {
    // 	type: String,
    // 	default: '' //是否修改
    // },
  },
  data() {
    return {
      applyChangeTxt: "",
      kw: "",
      height: "48",
      borderWidth: "1.4",
      width: 300,
      border: "",
      typeName: "",
      radioList: [
        {
          label: "事业",
          value: "",
        },
        {
          label: "国企",
          value: "",
        },
        {
          label: "民企",
          value: "",
        },
        {
          label: "其他",
          value: "",
        },
      ],
      sexRadio: [
        {
          label: "男",
          value: "",
        },
        {
          label: "女",
          value: "",
        },
      ],
      imgZD: [
        {
          name: "企业营业执照",
          name1: "企业营业执照",
          name2: "",
          label: "yyzzpath",
        },
        {
          name: "分支机构营业执照",
          name1: "分支机构",
          name2: "营业执照",
          label: "fzjgyyzzpath",
        },
        {
          name: "在黔负责人身份证正面",
          name1: "在黔负责人",
          name2: "身份证正面",
          label: "fzrsfzzmpath",
        },
        {
          name: "在黔负责人身份证反面",
          name1: "在黔负责人",
          name2: "身份证反面",
          label: "fzrsfzfmpath",
        },
        {
          name: "自律承诺书",
          name1: "自律承诺书",
          label: "zlcnspath",
        },
      ],
      imgOption: {
        maxSize: 2048,
        format: ["jpg", "jpeg", "png"],
        data: {
          type: 11,
        },
      },
      form: {
        yyzzpath: "",
        fzjgyyzzpath: "",
        fzrsfzzmpath: "",
        fzrsfzfmpath: "",
        zlcnspath: "",
        type: 2,
        changeReason: "", // 变更原因
        kz: {
          zqjbFzjgmc: "",
          zqjbTyxydm: "",
          isOffice: "0", // 入黔类型 0：分公司，1：办事处
          areaCodeArr: [],
        },
        companyType: null,
        areaCode: "",
        areaName: "",
        areaCodeArr: "",
        isOffice: "0", // 入黔类型
      },
      isShow: true,
      file_name: "", //当前文件名
      imgUrl: "",
      visible: false,
      isOffice: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      companyTypeList: [],
      propsCity: {
        lazy: true, // 启用懒加载
        lazyLoad: this.loadNode, // 指定懒加载方法
        // value: "code", // 数据唯一标识字段
        // label: "name", // 显示文本字段
        children: "children", // 子节点字段
        checkStrictly: false, // 是否严格遵循父子不关联
      },
      addData: [],
    };
  },
  mounted() {
    if (this.$Cookies.get("xh_userInfo")) {
      let userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
      let userName = userInfo.user.ext1;
      this.getVipxx(userName);
    }
    this.getDictltemsByCode();
  },
  methods: {
    // 获取企业类型下拉选择数据
    getDictltemsByCode() {
      getQueryDictltemsByCode({
        code: "company_type",
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.companyTypeList = res.result;
        }
      });
    },
    async loadNode(node, resolve) {
      let fid = 0;
      // 根据节点层级设置父级ID
      if (node.level === 1) {
        fid = node.value; // 省级节点：取省级ID
      } else if (node.level === 2) {
        fid = node.value; // 市级节点：取市级ID
      }
      try {
        // 调用接口获取数据
        const res = await getDqCode({
          code: fid,
        });
        // 处理返回数据（根据实际接口结构调整）
        const rawData = res.result || [];
        // 转换数据格式
        const nodes = rawData.map((item) => ({
          value: item.code, // 节点值
          label: item.name, // 显示文本
          leaf: node.level >= 2, // 市级节点加载的数据设为叶子节点
        }));

        resolve(nodes);
      } catch (error) {
        console.error("数据加载失败:", error);
        resolve([]); // 必须调用resolve
      }
    },
    // 办事处状态下 单位基本情况（总公司）注册地区选择事件
    handleChange(val) {
      if (val.length > 2) {
        this.form.areaCode = val[2];
        let LabelStr =
          this.$refs.CityRef.getCheckedNodes()[0].pathLabels.join("");
        this.form.areaName = LabelStr;
      }
    },
    handleChangeZqjbQyzcdq(val) {
      console.log("val", val);
      if (val && val.length > 2) {
        this.form.kz.areaCode = val[2];
        let LabelStr =
          this.$refs.ZqCityRef.getCheckedNodes()[0].pathLabels.join("");
        this.form.kz.areaName = LabelStr;
      }
    },
    companyTypeChange(val) {
      console.log("val", val);
      this.form.companyType = val;
      // 企业类型选择
      if (val == "8") {
        this.imgZD.push({
          name: "自律承诺书",
          name1: "自律承诺书",
          label: "zlcnspath",
        });
        // this.form.zlcnspath = "";
        console.log(this.form);
      } else {
        const index = this.imgZD.findIndex(
          (item) => item.name === "自律承诺书",
        );
        if (index !== -1) {
          this.imgZD.splice(index, 1); // 删除第一个匹配项
        }
      }
      const uniqueImgZD = this.imgZD.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.name === item.name),
      );
      this.imgZD = uniqueImgZD;
    },
    getVipxx(username) {
      getVipxx({
        username,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let info = res.result.vipvo;
          // Object.keys(info.kz).map((v) => {
          //   info[`kz.${v}`] = info.kz[v];
          // });
          // delete info.kz;
          this.applyChangeTxt = res.result.applyChangeTxt;

          info.uuid = res.result.applyuuid;
          console.log(1111111111, info);
          info.kz.areaCodeArr = this.splitAreaCode(
            res.result.vipvo.kz.areaCode,
          );
          info.areaCodeArr = this.splitAreaCode(res.result.vipvo.areaCode);
          this.companyTypeChange(info.companyType);
          this.isOfficeChange(info.kz.isOffice);
          this.form = info;
          this.isShow = false;
          this.$nextTick(() => {
            this.isShow = true;
          });
        }
      });
    },
    isOfficeChange(val) {
      console.log("val", val);
      if (val == "0") {
        this.imgZD.push({
          name: "分支机构营业执照",
          name1: "分支机构",
          name2: "营业执照",
          label: "fzjgyyzzpath",
        });
      } else if (val == "1") {
        const index = this.imgZD.findIndex(
          (item) => item.name === "分支机构营业执照",
        );
        if (index !== -1) {
          this.imgZD.splice(index, 1); // 删除第一个匹配项
        }
      }
      const uniqueImgZD = this.imgZD.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.name === item.name),
      );
      this.imgZD = uniqueImgZD;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件  " + file.name + " 太大, 不能超过 2M.",
      });
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件的格式 " + file.name + " 不正确，请选择jpg或png.",
      });
    },
    handleSuccess(res, file) {
      this.form[this.file_name] = res.result.file.filefullpath;
    },
    handleView(name) {
      this.imgUrl = this.$previewImg + this.form[name];
      this.visible = true;
    },
    handleRemove(name) {
      this.form[name] = "";
    },
    toUpload(name) {
      this.file_name = name;
    },
    getLong(e) {
      this.form.kz.zqfzrCsny = e;
    },
    submit() {
      if (this.form.kz.isOffice == "1") {
        // 是办事处
        this.form.dwmc = this.form.dwmcMain;
        this.form.account = this.form.accountMain;
        // this.form.dwmcMain = this.form.dwmc;
        // this.form.accountMain = this.form.account;

        // this.form.kz.zqjbFzjgmc = "";
        // this.form.kz.zqjbTyxydm = "";
      } else if (this.form.kz.isOffice == "0") {
        // 分公司
        this.form.dwmc = this.form.kz.zqjbFzjgmc;
        this.form.account = this.form.kz.zqjbTyxydm;
        // this.form.kz.zqjbFzjgmc = this.form.dwmc;
        // this.form.kz.zqjbTyxydm = this.form.account;
        if (!this.form.kz.zqjbFzjgmc) {
          this.$Message.warning("请输入单位名称！");
          return;
        }
      }

      if (!this.form.accountMain) {
        this.$Message.warning("请输入统一社会信用代码！");
        return;
      }
      if (!this.form.areaCode) {
        this.$Message.warning("请选择企业注册地！");
        return;
      }
      if (!this.form.zcdz) {
        this.$Message.warning("请输入企业注册地详细地址！");
        return;
      }
      if (!this.form.dwxz) {
        this.$Message.warning("请选择单位性质！");
        return;
      }
      if (!this.form.zczj) {
        this.$Message.warning("请输入注册资金！");
        return;
      }
      if (!this.form.zgzrs) {
        this.$Message.warning("请输入职工总人数！");
        return;
      }
      if (!this.form.zjyszcrs) {
        this.$Message.warning("请输入中级及以上职称人数！");
        return;
      }
      if (!this.form.dwdh) {
        this.$Message.warning("请输入单位电话！");
        return;
      } else if (yzAllCall(this.form.dwdh)) {
        this.$Message.warning("单位电话格式不正确！");
        return;
      }

      if (!this.form.yb) {
        this.$Message.warning("请输入邮政编码！");
        return;
      }
      if (!this.form.qyyx) {
        this.$Message.warning("请输入企业邮箱！");
        return;
      } else if (yzEmail(this.form.qyyx)) {
        this.$Message.warning("企业邮箱格式不正确！");
        return;
      }

      if (!this.form.txdz) {
        this.$Message.warning("请输入通讯地址！");
        return;
      }
      // if (!this.form.kz.zqjbFzjgmc) {
      //   this.$Message.warning("请输入在黔分支机构名称！");
      //   return;
      // }
      // if (!this.form.kz.isOffice) {
      //   this.$Message.warning("请选择是否办事处！");
      //   return;
      // }
      // if (!this.form.kz.zqjbTyxydm) {
      //   this.$Message.warning("请输入在黔统一信用代码！");
      //   return;
      // }
      if (!this.form.kz.zqjbQyzcdq && this.form.kz.isOffice == "0") {
        this.$Message.warning("请输入在黔企业注册地区！");
        return;
      }
      if (!this.form.kz.zqjbTxdz) {
        this.$Message.warning("请输入在黔通讯地址！");
        return;
      }
      if (!this.form.kz.zqjbDwdh) {
        this.$Message.warning("请输入在黔单位电话！");
        return;
      }
      // if (yzAllCall(this.form.kz.zqjbDwdh)) {
      // 	this.$Message.warning('在黔单位电话格式不正确！');
      // 	return
      // }
      else if (!this.form.kz.zqjbZgzrs) {
        this.$Message.warning("请输入在黔职工总人数！");
        return;
      }
      if (!this.form.kz.zqjbZjyszcrs) {
        this.$Message.warning("请输入在黔中级及以上职称人数！");
        return;
      }
      if (!this.form.kz.zqjbQyyx) {
        this.$Message.warning("请输入在黔企业邮箱！");
        return;
      } else if (yzEmail(this.form.kz.zqjbQyyx)) {
        this.$Message.warning("在黔企业邮箱格式不正确！");
        return;
      }

      if (!this.form.kz.zqfzrName) {
        this.$Message.warning("请输入在黔负责人姓名！");
        return;
      }
      if (!this.form.kz.zqfzrSex) {
        this.$Message.warning("请选择在黔负责人性别！");
        return;
      }
      if (!this.form.kz.zqfzrCsny) {
        this.$Message.warning("请选择在黔负责人出生年月！");
        return;
      }
      if (!this.form.kz.zqfzrSfzh) {
        this.$Message.warning("请输入在黔负责人身份证号！");
        return;
      } else if (yzSfz(this.form.kz.zqfzrSfzh)) {
        this.$Message.warning("在黔负责人身份证号格式不正确！");
        return;
      }

      if (!this.form.kz.zqfzrQtshzw) {
        this.$Message.warning("请输入在黔负责人其他社会职务！");
        return;
      }
      if (!this.form.kz.zqfzrZc) {
        this.$Message.warning("请输入在黔负责人职称！");
        return;
      }
      if (!this.form.kz.zqfzrZzmm) {
        this.$Message.warning("请输入在黔负责人政治面貌！");
        return;
      }
      if (!this.form.kz.zqfzrXl) {
        this.$Message.warning("请输入在黔负责人学历！");
        return;
      }
      if (!this.form.kz.zqfzrZy) {
        this.$Message.warning("请输入在黔负责人专业！");
        return;
      }
      if (!this.form.kz.zqfzrSjhm) {
        this.$Message.warning("请输入在黔负责人手机号码！");
        return;
      } else if (yzPhone(this.form.kz.zqfzrSjhm)) {
        this.$Message.warning("在黔负责人手机号码格式不正确！");
        return;
      }

      if (!this.form.kz.lxrName) {
        this.$Message.warning("请输入联系人姓名！");
        return;
      }
      if (!this.form.kz.lxrSex) {
        this.$Message.warning("请选择联系人性别！");
        return;
      }
      if (!this.form.kz.lxrSjhm) {
        this.$Message.warning("请输入联系人手机号码！");
        return;
      } else if (yzPhone(this.form.kz.lxrSjhm)) {
        this.$Message.warning("联系人手机号码格式不正确！");
        return;
      }

      if (!this.form.kz.lxrZw) {
        this.$Message.warning("请输入联系人职务！");
        return;
      }
      if (!this.form.kz.lxrBgdh) {
        this.$Message.warning("请输入联系人办公电话！");
        return;
      }
      // else if (yzAllCall(this.form.kz.lxrBgdh)) {
      // 	this.$Message.warning('联系人办公电话格式不正确！');
      // 	return
      // }

      if (!this.form.kz.lxrYx) {
        this.$Message.warning("请输入联系人邮箱！");
        return;
      } else if (yzEmail(this.form.kz.lxrYx)) {
        this.$Message.warning("联系人联系人邮箱！");
        return;
      }

      if (!this.form.yyzzpath) {
        this.$Message.warning("请上传企业营业执照！");
        return;
      }
      if (this.form.kz.isOffice == "0" && !this.form.fzjgyyzzpath) {
        this.$Message.warning("请上传分支机构营业执照！");
        return;
      }
      if (!this.form.fzrsfzzmpath) {
        this.$Message.warning("请上传在黔负责人身份证正面！");
        return;
      }
      if (!this.form.fzrsfzfmpath) {
        this.$Message.warning("请上传在黔负责人身份证反面！");
        return;
      }
      if (!this.form.zlcnspath && this.form.companyType == "8") {
        this.$Message.warning("请上传自律承诺书！");
        return;
      }
      if (!this.form.changeReason) {
        this.$Message.warning("请输入变更原因！");
        return;
      }
      // if (!this.form.rhsqbpath) {
      //   this.$Message.warning("请上传入会申请表！");
      //   return;
      // }
      console.log("this.form", this.form, this.kw);
      applicationUpdateApply({ ...this.form, dxyzm: this.kw }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.$Modal.success({
            title: "提示",
            content: "修改成功！",
            onOk: () => {
              this.$router.go(-1);
            },
          });
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.message,
            onOk: () => {},
          });
        }
      });
    },
    toSearch() {
      if (this.kw == "") {
        this.$Message.warning("请输入验证码查询！");
        return;
      }
      // this.typeName = this.kw
      infoQuery({
        type: 6,
        dxyzm: this.kw,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          if (res.result.code == 0) {
            let info = res.result.vipxx;
            info.kz = res.result.kz;
            Object.keys(info.kz).map((v) => {
              info[`kz.${v}`] = info.kz[v];
            });

            delete info.kz;
            // info.uuid = res.result.applyuuid;
            this.form = info;
          } else {
            this.$Message.error(res.result.message);
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    splitAreaCode(code) {
      // 确保输入为6位字符串
      if (typeof code !== "string" || code.length !== 6) {
        return [];
      }
      return [
        code.substring(0, 2), // 省级（前2位）
        code.substring(0, 4), // 市级（前4位）
        code, // 县级（完整6位）
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.applyChangeTxt {
  text-align: center;
  color: red;
  font-size: 18px;
  font-weight: bold;
}
.inp {
  flex: 1;

  /deep/ .ivu-input {
    height: var(--height);
    border-radius: 0;
    border: none;
    width: 100%;
  }

  /deep/ .ivu-input:focus {
    box-shadow: 0 0 0 2px transparent;
  }

  /deep/ .el-radio__input.is-disabled + span.el-radio__label {
    color: #000;
  }

  ///deep/ .el-radio__input.is-disabled .el-radio__inner,
  //.el-radio__input.is-disabled.is-checked .el-radio__inner {
  //  border-color: #409eff;
  //}
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #409eff;
    background: #409eff;
  }

  /deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
    background-color: #f5f7fa;
  }

  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #409eff !important;
  }

  /deep/ .el-input__inner {
    color: #000000;
    font-size: 16px;
  }

  /deep/ .el-radio__label {
    font-size: 16px;
  }
}

.table_box {
  font-size: 16px;
  letter-spacing: 5px;
  margin-top: 30px;

  > div {
    margin: 10px 0;
  }

  .cell1 {
    display: flex;
    border: var(--border);

    .cell_item {
      display: flex;
      align-items: center;
      width: 100%;

      > div {
        width: 50%;
        display: flex;
      }

      .tit {
        border-right: var(--border);
        background-color: #d2f3ff;
        padding: 0 30px;
        height: var(--height);
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
      }
      .account {
        letter-spacing: 1px;
        padding: 4px 7px;
      }

      .titX {
        border-left: var(--border);
      }

      .inp {
        width: 80%;
      }
    }
  }

  .cell2 {
    display: flex;

    .tit {
      flex: 1;
      border: var(--border);
      background-color: #d2f3ff;
      height: var(--height);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 10px;
      width: 15%;
      height: auto;
    }
    .account {
      letter-spacing: 1px;
      padding: 4px 7px;
      color: #000;
      font-size: 18px;
    }
    .table_item {
      width: 85%;
      border: var(--border);
      border-bottom: none;

      .table_cell {
        display: flex;
        border-bottom: var(--border);

        .td_item {
          display: flex;
          align-items: center;
          width: var(--gWidth);

          .td {
            border-right: var(--border);
            border-left: var(--border);
            background-color: #f2f2f2;
            width: 140px;
            height: var(--height);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;
          }

          .radio_box {
            padding: 0 20px;
            display: flex;
            justify-content: space-around;
            flex: 1;

            .ivu-radio-wrapper {
              font-size: 14px;
              margin-right: 15px;
              font-weight: normal;
            }

            .ivu-radio-wrapper:last-child {
              margin: 0;
            }

            /deep/ .ivu-radio-inner {
              border-radius: 0;
            }

            /deep/ .ivu-radio-checked {
              .ivu-radio-inner {
                background-color: #2d8cf0;
              }

              .ivu-radio-inner::after {
                display: none;
              }
            }
          }
        }

        .td_item:last-child {
          flex: 1;
        }

        .td_item:first-child {
          .td {
            border-left: none;
          }
        }
      }
    }

    .img_box {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      border-bottom: var(--border);

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 20px;
      }

      .img {
        width: 100px;
        height: 100px;
        // border: var(--border);
        margin-bottom: 20px;

        .jia {
          font-size: 60px;
          font-weight: bold;
          color: #999;
        }
      }

      /deep/ .ivu-upload-drag {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .demo-upload-list {
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        margin-right: 4px;
      }

      .demo-upload-list img {
        width: 100%;
        height: 100%;
      }

      .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
      }

      .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
      }

      .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
      }
    }
  }
  .changeReason {
    height: 150px;
  }
}

.btn {
  font-size: 23px;
  letter-spacing: 60px;
  padding-left: 80px;
  margin-top: 50px;
  font-weight: bold;
  background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.4);
}

/deep/ .ivu-input {
  color: #000;
  font-size: 18px;
}

/deep/ .ivu-input-suffix {
  display: flex;
  align-items: center;
}

.common_search_box {
  width: 400px;
  margin-top: 20px;
  margin-bottom: -10px;

  /deep/ .ivu-input {
    height: 40px;
  }

  .btn_box {
    height: 40px;
  }
}
</style>
